import(/* webpackMode: "eager" */ "/home/jetrails/pwa.awbridal.com/html/node_modules/.pnpm/next@14.2.35_@babel+core@7.26.10_react-dom@18.2.0_react@18.2.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/jetrails/pwa.awbridal.com/html/src/assets/images/convention/designscholarship/RelatedInt3.jpg");
;
import(/* webpackMode: "eager" */ "/home/jetrails/pwa.awbridal.com/html/src/assets/images/convention/designscholarship/RelatedInt4.jpg");
;
import(/* webpackMode: "eager" */ "/home/jetrails/pwa.awbridal.com/html/src/assets/images/convention/designscholarship/RelatedIntSocial1.jpg");
;
import(/* webpackMode: "eager" */ "/home/jetrails/pwa.awbridal.com/html/src/assets/images/convention/designscholarship/RelatedIntSocial2.jpg");
;
import(/* webpackMode: "eager" */ "/home/jetrails/pwa.awbridal.com/html/src/assets/images/convention/designscholarship/socialscholarship_m.jpg");
;
import(/* webpackMode: "eager" */ "/home/jetrails/pwa.awbridal.com/html/src/assets/images/convention/designscholarship/socialscholarship.jpg");
;
import(/* webpackMode: "eager" */ "/home/jetrails/pwa.awbridal.com/html/src/assets/images/convention/designscholarship/winner-m.png");
;
import(/* webpackMode: "eager" */ "/home/jetrails/pwa.awbridal.com/html/src/assets/images/convention/designscholarship/winner.png");
;
import(/* webpackMode: "eager" */ "/home/jetrails/pwa.awbridal.com/html/src/components/2024-scholarship-program-page/index.module.css");
